import { Navigate } from 'react-router-dom'

type Props = {
  isAuthenticated: boolean
}

export const UnknownPageHandler = ({ isAuthenticated }: Props) => {
  const navigateTo = !isAuthenticated ? '/login' : '/'
  return <Navigate to={navigateTo} replace />
}
